export default [
    {
        path: '/registration/list',
        component: require('@/pages/RegistrationList').default,
        meta: {
            crumbs: [],
            security: (auth) => auth.can({ action: 'list', model: 'registration' })
        }
    },
]
